"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Product = _interopRequireDefault(require("@deosite/ui-entities/Product"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Image = _interopRequireDefault(require("../Image"));
var _RouteContext = require("@deosite/lib/RouteContext");
var __jsx = _react["default"].createElement;
var SquareCardWithLabel = function SquareCardWithLabel(props) {
  var productData = props.productData;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(Link, {
    route: productData.url
  }, __jsx(_LinkRaw["default"], {
    sx: {
      textAlign: "center",
      font: "body2",
      color: "main"
    }
  }, __jsx(_Image["default"], {
    overlay: true,
    sx: {
      marginBottom: "s4"
    },
    sizes: "(max-width: 1350px) and (min-width: 10px) 210px, 420px",
    image: productData.image
  }), productData.name));
};
var _default = SquareCardWithLabel;
exports["default"] = _default;